import { useEffect, useState } from "react";
import { GetAllStates } from "../../../../services/CommonService";
import AddStates from "./AddStates";
import StatesTable from "./StatesTable";

const States=()=>{
    const [data, setData] = useState([]);
	useEffect(() => {
		getstates();
	}, []);  

   const getstates=async() =>{
    const statesdata = await GetAllStates({});
    setData(statesdata.data.docs);
   }
    return(<>
{data.length>0 && 
      <StatesTable propdata={data}/>}

      {console.log("statesdata",data)}
    </>)
}
export default States;